import { BehaviorSubject } from "rxjs";

export const TimelineTaskInfoSubject = new BehaviorSubject({});
